// extracted by mini-css-extract-plugin
export default {"cardMedia":"LS-z","shopText":"MS-z","videoPlayer":"NS-z","videoContainer":"OS-z"};